/**
 * @generated SignedSource<<5854c96bccfd449c5011d8437d5e83c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PersonNoteUpdateMutation$variables = {
  note: string;
  noteId: number;
};
export type PersonNoteUpdateMutation$data = {
  readonly updatePersonNote: {
    readonly personNote: {
      readonly created_by: string | null | undefined;
      readonly creator_email: string | null | undefined;
      readonly id: number;
      readonly note: string;
      readonly updated_at: any;
      readonly user_account: {
        readonly id: number;
        readonly user: {
          readonly email: string;
          readonly first_name: string | null | undefined;
          readonly id: number;
          readonly last_name: string | null | undefined;
        };
      } | null | undefined;
      readonly user_id: number | null | undefined;
    } | null | undefined;
  };
};
export type PersonNoteUpdateMutation = {
  response: PersonNoteUpdateMutation$data;
  variables: PersonNoteUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "note"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "note",
        "variableName": "note"
      },
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      }
    ],
    "concreteType": "PersonNote",
    "kind": "LinkedField",
    "name": "updatePersonNote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "people_notes",
        "kind": "LinkedField",
        "name": "personNote",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "note",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updated_at",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created_by",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "creator_email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "user_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "user_accounts",
            "kind": "LinkedField",
            "name": "user_account",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "users",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "first_name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "last_name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PersonNoteUpdateMutation",
    "selections": (v3/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PersonNoteUpdateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "cc661a5b263c6eef82bf61ef98049d8e",
    "id": null,
    "metadata": {},
    "name": "PersonNoteUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation PersonNoteUpdateMutation(\n  $noteId: Int!\n  $note: String!\n) {\n  updatePersonNote(noteId: $noteId, note: $note) {\n    personNote {\n      id\n      note\n      updated_at\n      created_by\n      creator_email\n      user_id\n      user_account {\n        id\n        user {\n          id\n          first_name\n          last_name\n          email\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0134a3ebd298c643fcbea52d23a98f69";

export default node;
